module.exports = __webpack_public_path__ + "img/product-placeholder-22.a1380f1.png";